import {
  Component,
  OnInit,
  inject,
  DOCUMENT
} from '@angular/core';
import {ClsConfig} from './util/cls-config';
import { IGX_DROP_DOWN_DIRECTIVES } from '@infragistics/igniteui-angular/drop-down';
import { IGX_NAVBAR_DIRECTIVES, IgxNavbarModule } from '@infragistics/igniteui-angular/navbar';
import { IGX_NAVIGATION_DRAWER_DIRECTIVES, IgxNavigationDrawerModule } from '@infragistics/igniteui-angular/navigation-drawer';
import { IgxButtonModule, IgxLayoutModule } from '@infragistics/igniteui-angular/directives';
import { IgxIconService } from '@infragistics/igniteui-angular/icon';
import {AppInfoService} from './core/services/app-info.service';
import {KeyLocalStorage} from './core/models/enum/emun-enumeracion';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {ThemeService} from './core/services/theme.service';
import {RouterOutlet} from '@angular/router';
import {FormsModule} from "@angular/forms";
import {TraduccionService} from "./core/services/traduccion.service";
import {DinamicoHostComponent} from "./componentes/util/notificaciones/dinamico-host.component";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [
    RouterOutlet,
    IgxNavigationDrawerModule,
    IGX_NAVIGATION_DRAWER_DIRECTIVES,
    IgxLayoutModule,
    IgxNavbarModule,
    IGX_NAVBAR_DIRECTIVES,
    TranslateModule,
    IgxButtonModule,
    IGX_DROP_DOWN_DIRECTIVES,
    FormsModule,
    DinamicoHostComponent
  ]
})
export class AppComponent extends ClsConfig implements OnInit {
  public document = inject(DOCUMENT);
  private translate = inject(TranslateService);
  private themeSer = inject(ThemeService);
  private appInfAppSer = inject(AppInfoService);
  private iconService = inject(IgxIconService);
  private traduccion = inject(TraduccionService);

  constructor() {
    super();
  }

  public ngOnInit(): void {
    const lenguaje: string = localStorage.getItem(KeyLocalStorage.Lenguaje);
    this.traduccion.cambiarLenguaje(lenguaje, this.document, this.translate, this.appInfAppSer);
    this.iconService.addSvgIcon('youtube', '../assets/imagenes/youtube.svg', 'material');
    this.iconService.addSvgIcon('facebook', '../assets/imagenes/facebook.svg', 'material');
    // this.iconService.addSvgIcon('soporte', '/assets/imagenes/Soporte.svg', 'material');
    // this.iconService.addSvgIcon('videos', '/assets/imagenes/Videos.svg', 'material');
    this.iconService.addSvgIcon('contiene', '/assets/imagenes/contains.svg', 'edicion');
    this.iconService.addSvgIcon('iniciar_con', '/assets/imagenes/starts-with.svg', 'edicion');
    this.appInfAppSer.app = this;
    this.appInfAppSer.documento = this.document;
    this.themeSer.setTema();
  }
}
